import React, { useEffect } from "react";

import CardClientes from "../components/cardClientes";
import useStore from "../store/useStore";

export default function Clients() {
  const { testimonioclientes, fetchTestimonioById } = useStore();
  useEffect(() => {
    fetchTestimonioById();
  }, [fetchTestimonioById]);

  // const clientesMock = [
  //   {
  //     id: 8,
  //     documentId: "au4rlratpjog6aansxbu28p1",
  //     nombre: "Agustín Berger",
  //     cargo: "Líder de Proyectos de IT",
  //     estrellas: 5,
  //     comentario:
  //       "La plataforma de comercio exterior SIDOM GT optimizó procesos de importación complejos en Argentina, y facilitó la regionalización en Chile, Paraguay, Bolivia y Uruguay. Esto permitió constituir un Shared Service Center desde Argentina para todo el Cono Sur.",
  //     img: "https://sidomsuite.com/wp-content/uploads/2024/09/QUILMES-Agustin-Berger-.jpg",
  //   },
  //   {
  //     id: 9,
  //     documentId: "xo3rhg9cl391uwh9rm6mz6yu",
  //     nombre: "Agustín Berger",
  //     cargo: "Líder de Proyectos de IT",
  //     estrellas: 4,
  //     comentario:
  //       "SIDOM nos permitió optimizar la gestión de comercio exterior y mejorar la eficiencia de nuestros procesos.",
  //     img: "https://sidomsuite.com/wp-content/uploads/2024/09/QUILMES-Agustin-Berger-.jpg",
  //   },
  //   {
  //     id: 10,
  //     documentId: "nrdadd8233y89p71yfb8yzc6",
  //     nombre: "Joaquín Banic",
  //     cargo: "Chief Methodologies & Processes",
  //     estrellas: 5,
  //     comentario:
  //       "El respeto y la respuesta inmediata ante consultas sobre SIDOM nos permite avanzar constantemente en nuestros objetivos.",
  //     img: "https://sidomsuite.com/wp-content/uploads/2024/09/QUILMES-Agustin-Berger-.jpg",
  //   },
  // ];
  return (
    <div className="container relative  py-16 text-sidom-dark dark:text-sidom-light bg-sidom-light dark:bg-sidom-blue">
      <div className="flex flex-col  pb-2 text-center">
        <h3 className="font-extrabold text-center text-4xl md:text-5xl text-sidom-orange mb-4">
          Testimonios
        </h3>
        <p className="max-w-xl mb-4 mx-auto">
          This is just a simple text made for this unique and awesome template,
          you can replace it with any text.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 md:grid-cols-2 justify-center align-center gap-6">
        {testimonioclientes.map((item) => (
          <CardClientes
            key={item.id}
            image={item.img?.formats?.thumbnail?.url}
            name={item.nombre}
            title={item.cargo}
            desc={item.comentario}
            rating={item.estrellas}
          />
        ))}
      </div>
    </div>
  );
}
